// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileHeader_wrapper__qHiLF","left":"MobileHeader_left___aSfY","right":"MobileHeader_right__4oK_f"};